import styled from '@emotion/styled'
import { Col } from 'react-bootstrap'

export const TotalFinanced = styled(Col)`
  label: TotalFinanced;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) =>
    props.bold ? (props.theme.brand === 'Maxxia' ? 800 : 900) : 400};
`
